/*
  CDS — Ajout rapide (quick add) depuis les cartes produit.
  Bouton : [data-cds-quick-add] avec data-variant-id="<id>".
  - Clic => POST /cart/add.js, puis dispatch 'cart:update' (morph drawer + compteur),
    ouverture forcée du drawer.
  - Le compteur de la bulle reçoit le VRAI total (récupéré via /cart.js) => pas de refresh.
  - Le bouton se grise (.is-incart) si l'article est déjà au panier (digital : 1 seul),
    synchro au chargement + sur 'cart:update' (ajout/retrait depuis n'importe où).
  window.cdsQuickAddSync() : à appeler après un rendu JS de cartes (ex. favoris).
*/
(function () {
  if (window.__cdsQuickAdd) return;
  window.__cdsQuickAdd = true;

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids.join(',');
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') {
      try { d.open(); } catch (e) {}
    }
  }

  function setInCart(btn, inCart) {
    btn.classList.toggle('is-incart', !!inCart);
    btn.setAttribute('aria-disabled', inCart ? 'true' : 'false');
  }

  function applyInCart(cart) {
    var ids = {};
    (cart && cart.items ? cart.items : []).forEach(function (it) { ids[String(it.variant_id)] = true; });
    document.querySelectorAll('[data-cds-quick-add]').forEach(function (btn) {
      var vid = btn.getAttribute('data-variant-id');
      setInCart(btn, vid && ids[vid]);
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function sync() {
    getCart().then(applyInCart).catch(function () {});
  }
  window.cdsQuickAddSync = sync;

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest ? e.target.closest('[data-cds-quick-add]') : null;
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-incart') || btn.classList.contains('is-loading')) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('is-loading');

      var body = { id: variantId, quantity: 1 };
      var sids = sectionIds();
      if (sids) body.sections = sids;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (added) {
          btn.classList.remove('is-loading');
          setInCart(btn, true);

          // Panier à jour => vrai total pour la bulle + état des boutons
          return getCart().then(function (cart) {
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = {
              resource: {},
              sourceId: 'cds-quick-add',
              data: {
                source: 'cds-quick-add',
                variantId: String(variantId),
                itemCount: cart.item_count, // total => compteur correct, sans refresh
                sections: (added && added.sections) || {}
              }
            };
            document.dispatchEvent(ev);
            openDrawer();
            applyInCart(cart);
          });
        })
        .catch(function () {
          btn.classList.remove('is-loading');
        });
    },
    true
  );

  // Resync si le panier change depuis ailleurs (drawer, suppression, etc.)
  document.addEventListener('cart:update', function (e) {
    if (e && e.detail && e.detail.sourceId === 'cds-quick-add') return; // déjà traité
    setTimeout(sync, 80);
  });

  if (document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);
})();
